/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ApplicationEnum } from '../model/applicationEnum';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SmsDeliveryService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param Msisdn 
     * @param Message 
     * @param DeliveryTime 
     * @param Application 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSmsDeliverySendSmsPost(Msisdn?: string, Message?: string, DeliveryTime?: Date, Application?: ApplicationEnum, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public apiSmsDeliverySendSmsPost(Msisdn?: string, Message?: string, DeliveryTime?: Date, Application?: ApplicationEnum, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public apiSmsDeliverySendSmsPost(Msisdn?: string, Message?: string, DeliveryTime?: Date, Application?: ApplicationEnum, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public apiSmsDeliverySendSmsPost(Msisdn?: string, Message?: string, DeliveryTime?: Date, Application?: ApplicationEnum, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (Msisdn !== undefined && Msisdn !== null) {
            queryParameters = queryParameters.set('Msisdn', <any>Msisdn);
        }
        if (Message !== undefined && Message !== null) {
            queryParameters = queryParameters.set('Message', <any>Message);
        }
        if (DeliveryTime !== undefined && DeliveryTime !== null) {
            queryParameters = queryParameters.set('DeliveryTime', <any>DeliveryTime.toISOString());
        }
        if (Application !== undefined && Application !== null) {
            queryParameters = queryParameters.set('Application', <any>Application);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('post',`${this.basePath}/api/SmsDelivery/SendSms`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
